<template>
  <ModalLayout icon="delete" title="Delete flight?" @close="close">
    Are you sure you want to delete <strong>{{ this.meta?.flight?.name }}</strong
    >? This action cannot be undone.
    <template slot="footer">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" @click="ctaDelete" :loading="loading" icon="el-icon-delete" type="danger">Delete</el-button>
    </template>
  </ModalLayout>
</template>
<script>
import ModalLayout from './ModalLayout.vue'
export default {
  name: 'SendToReview',
  components: { ModalLayout },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async ctaDelete() {
      this.loading = true
      await this.$store.dispatch('socialBoostCampaign/deleteFlight', {
        id: this.$route.params.id,
        flight_id: this.meta.flight.id,
        redirect: this.meta.redirectTo,
      })
      if (this.meta.redirectTo) {
        this.$router.push(this.meta.redirectTo)
      }
      this.close()
      this.loading = false
    },
  },
}
</script>
